import React from 'react';
import { useState, useCallback } from "react";

export const StepDescription = ({ description, stepId }) => {
  const [open, setOpen] = useState(false);

  const handleToggle = useCallback(() => setOpen((open) => !open), []);

  if (description.includes("<!--break-->")) {
    const arr = description.split("<!--break-->");
    return (
      <div className={`text-sm mt-[1.75rem] leading-6 ${stepId === "intro" ? 'text-center font-bold' : ''}`}>
        <p className="inline">{arr[0]}</p>
        {open && <p className="inline">{arr[1]}</p>}
        <button className={`inline-flex items-center ${open ? "ml-[0.25rem]" : ""}`} onClick={handleToggle}>
          <span className="font-bold underline underline-offset-4 mr-[0.25rem]">read {open ? "less" : "more"}</span>
          <svg className={open ? "rotate-180" : "rotate-0"} width="8" aria-hidden="true" focusable="false" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.99944 3.68389L6.88694 0.796387L7.71178 1.62122L3.99944 5.33355L0.287109 1.62122L1.11194 0.796387L3.99944 3.68389Z" fill="black"/>
          </svg>
        </button>
      </div>
    )
  } else {
    return (
      <div className={`text-[1rem] mt-[1.75rem] leading-7 ${stepId === "intro" ? 'text-center font-medium' : ''}`} dangerouslySetInnerHTML={ {__html: description} }></div>
    )
  }
};